export const list = {
  REQUEST: 'Annex/List/Request',
  SUCCESS: 'Annex/List/Success',
  FAILURE: 'Annex/List/Failure'
};

export const tree = {
  REQUEST: 'Annex/Tree/Request',
  SUCCESS: 'Annex/Tree/Success',
  FAILURE: 'Annex/Tree/Failure'
};

export const GET = {
  REQUEST: 'Annex/GET/Request',
  SUCCESS: 'Annex/GET/Success',
  FAILURE: 'Annex/GET/Failure'
};

export const CREATE = {
  REQUEST: 'Annex/CREATE/Request',
  SUCCESS: 'Annex/CREATE/Success',
  FAILURE: 'Annex/CREATE/Failure'
};

export const UPDATE = {
  REQUEST: 'Annex/UPDATE/Request',
  SUCCESS: 'Annex/UPDATE/Success',
  FAILURE: 'Annex/UPDATE/Failure'
};

export const DELETE = {
  REQUEST: 'Annex/DELETE/Request',
  SUCCESS: 'Annex/DELETE/Success',
  FAILURE: 'Annex/DELETE/Failure'
};

export const CLEAR = {
  SUCCESS: 'Annex/CLEAR/Success'
};
